import React from 'react';

export const facebookIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" role="img">
      <path d="m8.643 9.688.472-3.077H6.163V4.614c0-.841.413-1.662 1.735-1.662H9.24V.332S8.022.126 6.858.126c-2.431 0-4.02 1.474-4.02 4.141v2.345H.134v3.077h2.702v7.437h3.326V9.687h2.48Z" />
    </svg>
  );
};
